<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>マイ・ディクショナリー</h1>
                            <h2>自分だけの辞書を作って
                                カスタマイズされた校正を</h2>
                            <p>マイ・ディクショナリーへの単語の追加で、新語や固有名詞のスペルアラートを回避。ブランド名や新しい技術名などを追加すれば、Trinkaがそれを記憶し、どの端末からでもそれに応じた校正が可能です。</p>
                            <div class="btn-group">
                                <a href="https://cloud.trinka.ai/signup?_rg=JP" class="filled-btn" target="_blank">今すぐ始める</a>
                            </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="assets/images/features/personal-dictionary/Personal-Dictionary.webp" alt="トリンカ語の個人用辞書 - 文法 チェック">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="howItWorks section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src="assets/images/yt-thumbnail/MyDicitonayThumbnail.webp" alt="個人辞書 - 英文校正" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2">
                        <div class="trinka-title mb-0">
                            <h2>マイ・ディクショナリーの
                                使い方</h2>
                            <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                            <p>「マイ・ディクショナリー」の機能が分かるチュートリアル動画をご覧ください。</p>
                            <p>ステップごとの解説で、機能を余すところなくお使いいただけます</p>
                            <p>疑問点については
                                <a style="color: #0000ff;" (click)="scroll(target)" class="text-link remove-left-space">FAQ</a>もあわせてお読みください。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="writeToolboxs_section section-pd pb-0">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title mb-0 text-center">
                        <h2>マイ・ディショナリーの主な機能</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>不要な修正案を回避し、より効率的にライティングを行っていただけます。</p>
                    </div>
                </div>
            </div>
        </div>

        <section class="section-pd list-wrapper-style-2">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>単語のカテゴライズ</h3>
                            <p>追加した単語は、正しいスペル、実験方法の名前、生物学上の名称、製品名など、カテゴリーに分けて整理できます。カスタマイズをすればするほどTrinkaが学習し、精度も高まります。</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image">
                            <img src="assets/images/features/personal-dictionary/correct-spelling.webp" alt="単語の分類 - 文法 チェック" class="img-fluid md50">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3>大文字・小文字の区別の調整</h3>
                            <p>登録した用語に対して、大文字表記・小文字表記との合致を判別するかどうかの設定が可能です。</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="assets/images/features/personal-dictionary/case-sensitive.webp" alt="大文字と小文字を区別して調整する - 英文校正" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-pd list-wrapper-style-2">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>アメリカ英語／イギリス英語</h3>
                            <p>追加された用語に対して、選択した英語（アメリカ英語／イギリス英語）との合致を判別するかどうかを設定できます。</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image">
                            <img src="assets/images/features/personal-dictionary/american-english.webp" alt="英語タイプを選択してください - 英文チ ェッカー" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="list-wrapper-style-2 pt-0">
            <div class="trinka_container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2 pr-80">
                            <h3>プラットフォームをまたいだ統一</h3>
                            <p>マイ・ディクショナリーに追加した単語は、すべてのプラットフォームで自動的に同期されます。Trinka Cloud、Wordプラグイン、ブラウザプラグインのいずれでも、マイ・ディクショナリーが機能します。</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image features-img">
                            <img src="assets/images/features/personal-dictionary/SyncAcrossPlatforms.webp" alt="プラットフォーム間で同期 - 文法 チェック" class="img-fluid" style="max-width: 300px;">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-pd list-wrapper-style-2">
            <div class="trinka_container">
                <div class="row align-items-center flex-row-reverse">
                    <div class="col-md-6">
                        <div class="list-wrapper-content-2">
                            <h3>ブランドトーンの統一
                                <span class="beta-badges">Enterprise</span>
                            </h3>
                            <p>組織特有の語彙や新しい用語を追加することで、統一したトーンでライティングを行い、あらゆる情報発信の場でブランドイメージを保つことができます。</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="list-wrapper-image">
                            <img src="assets/images/features/personal-dictionary/MyDictionary_Brand-tone.webp" alt="ブランドトーンを維持する - 英文 チェック" class="img-fluid" style="max-width: 320px;">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
   

    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">自分だけの辞書で、パーソナライズドされた正確なライティングを<</h3>
                    </div>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" class="white-btn" target="_blank">今すぐ始める</a>
                    </div>
                </div>
            </div>  
        </div>
    </div>

    
    <div class="faqQuestionAnwser section-pd" #target>
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-10">
                    <div class="trinka-title text-center">
                        <h2>よくあるご質問
                        </h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="faqQuestionsList">
                <div class="accordion" id="faq">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionOne">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                            マイ・ディクショナリーに追加した言葉を、他人に見られることはありますか？</a>
                                    </div>
    
                                    <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                        <div class="card-body">
                                            <p>いいえ。マイ・ディクショナリーはユーザー本人のみのもので、他の人がアクセスしたり、使用することはできません。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionTwo">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                            aria-controls="QuestionTwoContent">マイ・ディクショナリーにはどこから入れますか？</a>
                                    </div>
    
                                    <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                        <div class="card-body">
                                            <p>
                                                Trinkaに
                                                <a href="https://cloud.trinka.ai/dashboard/profile" target="_blank">ログイン</a>後、アカウントページの「Acount Settings」からアクセスできます。「Writing Settings」の「My Dictionary」をクリックすると表示されます。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionThree">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                            aria-controls="QuestionThreeContent">
                                            マイ・ディクショナリーを他のアカウントと共有できますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                        <div class="card-body">
                                            <p>いいえ。他のアカウントと共有することはできません。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionFour">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                            aria-controls="QuestionFourContent">
                                            マイ・ディクショナリーをダウンロードすることはできますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                        <div class="card-body">
                                            <p>現在のところ、ダウンロードはできませんが、近日中にこのダウンロード機能を追加する予定です。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="otherApps section-pd-sm">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">もっとあります
                            Trinkaの
                            使い方</h3>
                    </div>
                    <ul>
                        <li>
                            <a [routerLink]="['/trinkacloud']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="cloud">
                                    <h3>Cloud</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/wordplugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Others_App_MSWord.svg" alt="ms word">
                                    <h3><span class="OpenSansFonts" style="font-weight: bold;">MS Word</span>
                                        <br /> プラグイン</h3>
                                </div>
                        </a>
                        </li>
                        <li>
                            <a [routerLink]="['/browser-plugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/other_Apps_browser.svg" alt="browser">
                                    <h3>ブラウザ
                                        <br />プラグイン</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/enterprise']">
                                <div class="app_name_content" style="padding: 0px;">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                    <h3 style="margin: 0 0 -2px 0;">Enterprise</h3>
                                    <span style="font-size: 12px; color: #000; position: relative;">(API, JS, & On-Premise)</span>
                                </div>
                            </a>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/5KsBh4PQUPI"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>